import { HiOutlineTrash } from "react-icons/hi";
import { LuTriangleAlert } from "react-icons/lu";
import API from "../../api";
import { capture } from "../../instrument";
import toast from "react-hot-toast";

const BatchDeletePrescriptionsModal = ({
  loading = false,
  setPrescriptionBatchLoading,
  selectedPrescriptions,
  setSelectedPrescriptions,
  setShowBatchDeletePrescriptionsModal,
  admissionSelected,
  getAdmissionDetails,
}) => {
  const batchDeletePrescriptions = async () => {
    setPrescriptionBatchLoading(true);
    const selectedPrescriptionIds = Array.from(selectedPrescriptions);

    try {
      for (const prescriptionId of selectedPrescriptionIds) {
        const { ok } = await API.delete(`/admin/admission/${admissionSelected._id}/prescription/${prescriptionId}`);
        if (!ok) throw new Error("Failed to delete prescription");
      }

      toast.success(
        `${selectedPrescriptionIds.length} prescription${selectedPrescriptionIds.length > 1 ? "s" : ""} supprimée${selectedPrescriptionIds.length > 1 ? "s" : ""} avec succès`
      );

      setSelectedPrescriptions(new Set());
      setShowBatchDeletePrescriptionsModal(false);
      getAdmissionDetails(admissionSelected._id);
    } catch (error) {
      capture(error);
      toast.error("Une erreur est survenue lors de la suppression des prescriptions");
    }
    setPrescriptionBatchLoading(false);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-[220] flex items-center justify-center">
      <div className="bg-white rounded-lg p-6 max-w-2xl w-full mx-4">
        <div className="flex items-center gap-3 mb-4">
          <div className="bg-red-100 rounded-full p-2">
            <HiOutlineTrash className="h-6 w-6 text-red-500" />
          </div>
          <h2 className="text-xl font-bold">Supprimer les prescriptions sélectionnées</h2>
        </div>

        <div className="mb-4">
          <div className="bg-yellow-50 border border-yellow-200 rounded-md p-3 mb-4">
            <div className="flex items-center gap-2">
              <LuTriangleAlert className="h-5 w-5 text-yellow-600" />
              <span className="text-sm text-yellow-800">
                Vous êtes sur le point de supprimer <span className="font-semibold">{selectedPrescriptions.size}</span> prescription{selectedPrescriptions.size > 1 ? "s" : ""}.
                Cette action est irréversible.
              </span>
            </div>
          </div>

          <p className="text-sm text-gray-600">Les prescriptions sélectionnées seront définitivement supprimées du dossier d'admission. Cette action ne peut pas être annulée.</p>
        </div>

        <div className="flex justify-end gap-3">
          <button
            className="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors"
            disabled={loading}
            onClick={() => setShowBatchDeletePrescriptionsModal(false)}
          >
            Annuler
          </button>
          <button
            className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed flex items-center gap-2"
            disabled={loading}
            onClick={batchDeletePrescriptions}
          >
            {loading ? (
              <>
                <div className="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full"></div>
                Suppression en cours...
              </>
            ) : (
              <>
                <HiOutlineTrash className="w-4 h-4" />
                Supprimer {selectedPrescriptions.size} prescription{selectedPrescriptions.size > 1 ? "s" : ""}
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BatchDeletePrescriptionsModal;
